<script lang="ts">
/**
 * @fileoverview
 *  Immedio の必須項目の hidden 用の値
 *  Immedio はいくつかの必須項目があるが、その中で「person_name」の項目は資料詳細画面にそれに該当するフォームが存在しないため、
 *  それにより、Immedio のスクリプト側で対象項目が見つからないというエラーが発生してしまう。
 *  なので、仮の hidden を設置することでエラーを解消する。
 *  ※ Immedio のスクリプト側で必須項目を拾うためのものなので、Bizhint のアプリケーションとしては使用しない。よって Immedio を使わなくなったら本コンポーネントも不要となる。
 */
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PersonNameForImmedio',

  props: {
    firstName: {
      type: String,
      default: '',
    },

    lastName: {
      type: String,
      default: '',
    },
  },
})
</script>

<template>
  <input
    class="input"
    type="hidden"
    name="person_name"
    :value="`${lastName} ${firstName}`">
</template>
